// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import i18n from "./locale/index";
import ElementUI, {Pagination} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "../build/reset.css";
import App from "./App";
import router from "./router";
import axios from "axios"; //引入
import "default-passive-events";
import tool from "./js/tool";
import "lib-flexible";

Vue.use(tool);
Vue.use(ElementUI);
Vue.prototype.$apiFun = axios; //请求接口api
Vue.config.productionTip = false;
Vue.prototype._i18n = i18n;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: {
    App,
    i18n
  },
  template: "<App/>"
});




// WEBPACK FOOTER //
// ./src/main.js